import { LayoutCards } from '@flatsy/core/Layout/Cards'
import React, { useContext } from 'react'
import { useMobile } from 'src/hooks/Mobile'
import ApplicantInformation from './ApplicantInformation'
import FilesList from './FilesList'
import { useStyles } from './Style'
import PreUploader from './PreUploader'
import { FileContext } from '../../Context'

const FilesOverview: React.FC = (): React.ReactElement => {
  const { application } = useContext(FileContext)
  const classes = useStyles()
  const mobile = useMobile()
  const isConnected = application?.lead?.dossier_facile_status
  return (
    <LayoutCards strongShadow className={classes.cards}>
      <ApplicantInformation />
      {!mobile && <PreUploader />}
      {!isConnected && <FilesList />}
    </LayoutCards>
  )
}

export default FilesOverview
